<template>
  <table class="table">
    <tr>
      <th>{{ $t("operational_security.operational_processes.folio") }}</th>
      <td class="fw-bold">{{ data.folio }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.status") }}</th>
      <td class="fw-bold">
        <b-badge
          v-if="data.status === 'finished'"
          variant="light-success"
          class="text-capitalize"
        >
          {{data.status_label}}
        </b-badge>
        <b-badge
          v-if="data.status === 'in_progress'"
          variant="light-info"
          class="text-capitalize"
        >
          {{data.status_label}}
        </b-badge>
        <b-badge
          v-if="data.status === 'partial'"
          variant="light-warning"
          class="text-capitalize"
        >
          {{data.status_label}}
        </b-badge>
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.check_in_datetime") }}</th>
      <td class="fw-bold">{{ data.check_in_datetime }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.company") }}</th>
      <td class="fw-bold">{{ data.company.name }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.employee") }}</th>
      <td class="fw-bold">
        <div v-if="Array.isArray(data.employees)">
          <b-badge
            v-for="(e, idx) in data.employees"
            :key="idx"
            variant="light-info"
            class="mr-25 mb-25"
          >
            {{ e.full_name_id ? e.full_name_id : "" }}
          </b-badge>
        </div>
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.report_number") }}</th>
      <td class="fw-bold">{{ data.report_number }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.activities") }}</th>
      <td class="fw-bold">
        <b-badge
          v-for="(act, idx) in data.activities"
          :key="idx"
          variant="light-primary"
          class="mr-25 mb-25"
        >
          {{ act.description }}
        </b-badge>
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.system") }}</th>
      <td class="fw-bold">
        <b-badge
          v-for="(sys, idx) in data.systems"
          :key="idx"
          variant="light-info"
          class="mr-25 mb-25"
        >
          {{ sys }}
        </b-badge>
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.is_test_mode_enabled") }}</th>
      <td class="fw-bold">{{ data.is_test_mode_enabled ? "Sí" : "No" }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.check_out_datetime") }}</th>
      <td class="fw-bold">
        {{ data.check_out_datetime ? data.check_out_datetime : " - " }}
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.type_of_maintenance") }}</th>
      <td class="fw-bold">{{ data.type_of_maintenance }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.tenant_origin") }}</th>
      <td class="fw-bold">{{ data.unit.router.tenant.name }}</td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.maintenance_devices") }}</th>
      <td class="fw-bold">
        <b-badge
          v-for="(device_proxy, idx) in data.device_proxies"
          :key="idx"
          variant="light-warning"
          class="mr-25 mb-25"
        >
          {{
            device_proxy &&
            device_proxy.cameras_proxy &&
            device_proxy.cameras_proxy.camera
              ? device_proxy.cameras_proxy.camera.name
              : ""
          }}
        </b-badge>
      </td>
    </tr>
    <tr>
      <th>{{ $t("operational_security.operational_processes.tenant") }}</th>
      <td class="fw-bold">{{ data.tenant ? data.tenant.name : " - " }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array | Object,
    },
  },
};
</script>

